var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { display: "flex" } },
        [
          _c(
            "el-row",
            {
              staticStyle: { flex: "1" },
              attrs: { type: "flex", justify: "space-between", gutter: 20 },
            },
            _vm._l(_vm.cardOptions, function (item, index) {
              return _c(
                "el-col",
                { key: index },
                [
                  _c("dataCard", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.cardLoading,
                        expression: "cardLoading",
                      },
                    ],
                    attrs: { option: item, active: 0 },
                    on: { clickPre: _vm.cardClick },
                  }),
                ],
                1
              )
            }),
            1
          ),
          _c("el-card", { staticStyle: { "margin-left": "20px" } }, [
            _c(
              "div",
              { staticClass: "setting", on: { click: _vm.ruleSetting } },
              [
                _c("i", {
                  staticClass: "iconfont icona-15shezhi",
                  staticStyle: { "font-size": "24px", color: "#999" },
                }),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "8px",
                      "font-size": "12px",
                      color: "#999",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("system::rbac::设置")))]
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "stockanaly--list__search" },
        [
          _c("z-search", {
            ref: "search",
            staticStyle: { "margin-bottom": "-12px" },
            attrs: { configs: _vm.searchConfigData },
            on: { "do-query": _vm.query },
            model: {
              value: _vm.searchData,
              callback: function ($$v) {
                _vm.searchData = $$v
              },
              expression: "searchData",
            },
          }),
          _c(
            "z-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                columns: _vm.tableColumns,
                data: _vm.tableData,
                "max-height": 532,
                "row-key": "keyId",
                lazy: "",
                load: _vm.loadSku,
                "tree-props": {
                  children: "children",
                  hasChildren: "hasChildren",
                },
                "show-header": "",
                pagination: _vm.pagination,
              },
              on: {
                "page-change": _vm.handlePageChange,
                "update:pagination": function ($event) {
                  _vm.pagination = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "stockHeader",
                  fn: function () {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("storage::stock-analysis::stock_in_comming")
                          )
                        ),
                      ]),
                      _c(
                        "el-tooltip",
                        { attrs: { effect: "dark", placement: "top-start" } },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "storage::stock-analysis::stock_in_amount"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c("i", {
                            staticClass: "icon-a-01wenhao iconfont-el",
                            staticStyle: {
                              "font-size": "14px",
                              "margin-left": "5px",
                              color: "#999",
                            },
                          }),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "stock",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._v(" " + _vm._s(row.advanceStock) + " ")]
                  },
                },
                {
                  key: "totalQuantity",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._v(" " + _vm._s(row.totalQuantity) + " ")]
                  },
                },
                {
                  key: "day",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._v(" " + _vm._s(row.contentDays) + " ")]
                  },
                },
                {
                  key: "dayHeader",
                  fn: function () {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("storage::stock-analysis::full_days"))
                        ),
                      ]),
                      _c(
                        "el-tooltip",
                        { attrs: { effect: "dark", placement: "top-start" } },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "storage::stock-analysis::full_days_tips",
                                      { day: _vm.ruleData.fixPinDays || 0 }
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c("i", {
                            staticClass: "icon-a-01wenhao iconfont-el",
                            staticStyle: {
                              "font-size": "14px",
                              "margin-left": "5px",
                              color: "#999",
                            },
                          }),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "prod",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "div",
                        { staticClass: "stockanalysis--table__imgTd" },
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "top-start",
                                trigger: "hover",
                                "append-to-body": true,
                              },
                            },
                            [
                              _c("ZImg", {
                                staticStyle: {
                                  width: "250px",
                                  height: "250px",
                                },
                                attrs: { src: row.imageUrl },
                              }),
                              _c("ZImg", {
                                staticClass: "images",
                                attrs: { slot: "reference", src: row.imageUrl },
                                slot: "reference",
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "div",
                                { staticClass: "stockanaly--list__name" },
                                [_vm._v(_vm._s(row.productName))]
                              ),
                              row.isSku
                                ? _c(
                                    "div",
                                    { staticClass: "stockanaly--list__spu" },
                                    [
                                      _vm._v(
                                        " SKU: " +
                                          _vm._s(row.skuId) +
                                          _vm._s(
                                            row.optionValueNames
                                              ? " | " + row.optionValueNames
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "stockanaly--list__spu" },
                                    [
                                      _vm._v(
                                        " SPU: " +
                                          _vm._s(row.spuId) +
                                          " " +
                                          _vm._s(
                                            row.productCategory
                                              ? " | " + row.productCategory
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                              row.suggestPurhcase !== ""
                                ? _c("el-tag", { attrs: { size: "small" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "storage::stock-analysis::purchase_suggest"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "sale",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.$t("storage::stock-analysis::three_day")) +
                            ": " +
                            _vm._s(row.salesThreeDays)
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.$t("storage::stock-analysis::seven_day")) +
                            ": " +
                            _vm._s(row.salesSevenDays)
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("storage::stock-analysis::fifteen_day")
                          ) +
                            ": " +
                            _vm._s(row.salesFifteenDays)
                        ),
                      ]),
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            placement: "left",
                            "popper-class": "popper-class",
                            trigger: "hover",
                            "append-to-body": true,
                          },
                          on: {
                            show: function ($event) {
                              return _vm.showReport(row)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "stockanaly--list__trend",
                              attrs: { slot: "reference" },
                              slot: "reference",
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../../assets/images/icon-data.png"),
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "storage::stock-analysis::sales_trend"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "675px",
                                "min-height": "400px",
                              },
                            },
                            [
                              _c("reportCard", {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.popoverLoading,
                                    expression: "popoverLoading",
                                  },
                                ],
                                ref:
                                  "prod" +
                                  (row.hasChildren ? row.spuId : row.skuId),
                                attrs: {
                                  config: _vm.configData[
                                    "prod" +
                                      (row.hasChildren ? row.spuId : row.skuId)
                                  ] || { height: "325px" },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "div",
                { attrs: { slot: "empty" }, slot: "empty" },
                [
                  _c("ZDefaultData", {
                    attrs: { custom: { height: "490px" } },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("rule-setting", {
        ref: "settingDialog",
        on: { success: _vm.initData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }